import React, { useState } from 'react';
import { formatPrice } from '../utils/formatPrice';
import { ProductAddon, OrderProductAddon, OrderProduct, Product } from '../interfaces';
import './itemActions.css';

interface EditAddonsForProductProps {
    orderProduct: OrderProduct;
    product: Product | undefined;
    onClose: () => void;
    onSave: (selectedAddons: OrderProductAddon[]) => void;
}

const EditAddonsForProduct: React.FC<EditAddonsForProductProps> = ({ orderProduct, onClose, onSave, product }) => {
    const [selectedAddons, setSelectedAddons] = useState<OrderProductAddon[]>(orderProduct.addons);

    const handleSelectAddon = (addon: ProductAddon) => {
        setSelectedAddons(prevState => {
            if (prevState.find(a => a.addon.id === addon.id)) return prevState;
            return [...prevState, { addon, qty: 1, addonId: addon.id, addonName: addon.name, price: addon.priceWithoutTax }];
        });
    };

    const handleIncrement = (addon: ProductAddon) => {
        setSelectedAddons(prevState => prevState.map(a => (a.addon.id === addon.id ? { ...a, qty: a.qty + 1 } : a)));
    };

    const handleDecrement = (addon: ProductAddon) => {
        setSelectedAddons(prevState => prevState.filter(a => !(a.addon.id === addon.id && a.qty <= 1)).map(a => (a.addon.id === addon.id ? { ...a, qty: a.qty - 1 } : a)));
    };

    return (
        <div className="tia-card">
            <div className="tia-mhead">
                <div>
                    <div className="tia-mtitle">Add-ons</div>
                    <div className="tia-msub">{orderProduct.name}</div>
                </div>
                <button className="tia-x" onClick={onClose} aria-label="Close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13M1 1L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </button>
            </div>
            <div className="tia-mbody">
                <div className="tia-addlist">
                    {product?.addons.map((addon) => {
                        const selected = selectedAddons.find((a) => a.addon.id === addon.id);
                        const qty = selected?.qty ?? 0;
                        return (
                            <div key={addon.id} className={`tia-addrow${qty > 0 ? ' is-on' : ''}`}>
                                <span className="tia-addname">{addon.name}</span>
                                <span className="tia-addprice">+{formatPrice(addon.priceWithoutTax)}</span>
                                {qty > 0 ? (
                                    <div className="tia-stepper">
                                        <button onClick={() => handleDecrement(addon)} aria-label="Decrease">
                                            <svg width="14" height="2" viewBox="0 0 16 2" fill="none"><path d="M1 1h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
                                        </button>
                                        <span>{qty}</span>
                                        <button onClick={() => handleIncrement(addon)} aria-label="Increase">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.2v11.6M1.2 7h11.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
                                        </button>
                                    </div>
                                ) : (
                                    <button className="tia-addbtn" onClick={() => handleSelectAddon(addon)}>Add</button>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="tia-mfoot">
                <span />
                <div className="tia-footright">
                    <button className="tia-btn tia-btn--ghost" onClick={onClose}>Cancel</button>
                    <button className="tia-btn tia-btn--primary" onClick={() => onSave(selectedAddons)}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default EditAddonsForProduct;
